import React, { useEffect, useState, useMemo, useCallback } from 'react';
import { useSelector } from 'react-redux';

import {
  ExpansionPanel,
  ExpansionPanelSummary,
  ExpansionPanelDetails,
  Typography,
} from '@material-ui/core';
import { differenceBy, concat, get, assign } from 'lodash';

import { isEmpty } from 'lodash';

import { Table } from '~/components';

import { ADM } from '~/constants/perfil';

import { Container } from './styles';
import * as S from './styles';

//export default function DadosUnidade({ onHandleAddItems, onHandleRemoveItem, data }) {
export default function DadosUnidade({ data }) {
  const { profile } = useSelector((state) => state.user);

  const [bloqueado, setBloqueado] = useState(false);
  
  const [rowsDisponiveis, setRowsDisponiveis] = useState(data.rowsDisponiveis);
  const [rowsSelecionadas, setRowsSelecionadas] = useState(data.rowsSelecionadas);
  

  useEffect(() => {
    // if (!isEmpty(data)) {
    //   setBloqueado(data.unidade.unid_bloqueio_inadimplencia === 'S');
    // }
  }, [data]);

  const [loading, setLoading] = useState(false);

  const handleRuleStyle = useCallback((data) => {
    if (data.poco_codigo === 'admin') {
      return {
        color: '#fff',
        background: '#096',
      };
    }
    return undefined;
  }, []);

  const handleFormatValue = useCallback((value) => {
    if (value === 'L') return 'Liberado';
    return 'Bloqueado';
  }, []);


  const headerPostos = useMemo(
    () => [
      {
        id: 'poco_desc_abrev',
        label: 'Postos',
        style: handleRuleStyle,
      },
      {
        id: 'poco_codigo',
        label: 'Código',
        align: 'center',
      },
    ],
    []
  );

  // const HandleAddItems = useCallback((arrayData) => {
  //   // const objSend = {
  //   //   ...data,
  //   //   rowsDisponiveis: differenceBy(data.rowsDisponiveis, arrayData, 'poco_codigo'),
  //   //   rowsSelecionadas: concat(data.rowsSelecionadas, arrayData),
  //   // };
  //   // setData(objSend);
  //   data.rowsDisponiveis = differenceBy(data.rowsDisponiveis, arrayData, 'poco_codigo');
  //   data.rowsSelecionadas = concat(data.rowsSelecionadas, arrayData);
    
  //   setRowsDisponiveis(differenceBy(rowsDisponiveis, arrayData, 'poco_codigo') );
  //   setRowsSelecionadas( concat(rowsSelecionadas, arrayData) );
  // }, [data]);


  // const HandleRemoveItem = useCallback((arrayData) => {
  //   // const objSend = {
  //   //   ...data,
  //   //   rowsDisponiveis: concat(data.rowsDisponiveis, arrayData),
  //   //   rowsSelecionadas: differenceBy(data.rowsSelecionadas, arrayData, 'poco_codigo'),
  //   // };
  //   // setData(objSend);
  //   data.rowsDisponiveis = concat(data.rowsDisponiveis, arrayData);
  //   data.rowsSelecionadas = differenceBy(data.rowsSelecionadas, arrayData, 'poco_codigo');
    
  //   setRowsDisponiveis(concat(rowsDisponiveis, arrayData) );
  //   setRowsSelecionadas( differenceBy(rowsSelecionadas, arrayData, 'poco_codigo') );
  // }, [data]);

  const HandleAddItems = useCallback((arrayData) => {
    // const objSend = {
    //   ...data,
    //   rowsDisponiveis: differenceBy(data.rowsDisponiveis, arrayData, 'poco_codigo'),
    //   rowsSelecionadas: concat(data.rowsSelecionadas, arrayData),
    // };
    // setData(objSend);
    const arrayDisponiveis = differenceBy(rowsDisponiveis, arrayData, 'poco_codigo');    
    const arraySelecionado = concat(rowsSelecionadas, arrayData);
    data.rowsDisponiveis = arrayDisponiveis; //differenceBy(data.rowsDisponiveis, arrayData, 'poco_codigo');
    data.rowsSelecionadas = arraySelecionado; //concat(data.rowsSelecionadas, arrayData);    
    setRowsDisponiveis(arrayDisponiveis );
    setRowsSelecionadas( arraySelecionado );
  }, [data,rowsDisponiveis,rowsSelecionadas]);


  const HandleRemoveItem = useCallback((arrayData) => {
    // const objSend = {
    //   ...data,
    //   rowsDisponiveis: concat(data.rowsDisponiveis, arrayData),
    //   rowsSelecionadas: differenceBy(data.rowsSelecionadas, arrayData, 'poco_codigo'),
    // };
    // setData(objSend);
    const arrayDisponiveis = concat(rowsDisponiveis, arrayData);   
    const arraySelecionado = differenceBy(rowsSelecionadas, arrayData, 'poco_codigo');
    data.rowsDisponiveis = arrayDisponiveis; //concat(data.rowsDisponiveis, arrayData);
    data.rowsSelecionadas = arraySelecionado; //differenceBy(data.rowsSelecionadas, arrayData, 'poco_codigo');    
    setRowsDisponiveis(arrayDisponiveis);
    setRowsSelecionadas(arraySelecionado);
  }, [data,rowsDisponiveis,rowsSelecionadas]);


  return (
    <>
      <S.Wrapper>
        <Table
          showCount
          search
          title="Postos disponíveis"
          checkbox
          cells={headerPostos}
          data={data.rowsDisponiveis}
          height="20rem"
          size="small"
          loading={loading}
          //onCallback={(values) => onHandleAddItems(values)}
          onCallback={(values) => HandleAddItems(values)}
          unique="unid_codigo"
        />

        <Table
          showCount
          search
          checkbox
          title="Postos selecionados"
          cells={headerPostos}
          data={data.rowsSelecionadas}
          height="20rem"
          size="small"
          //onCallback={(values) => onHandleRemoveItem(values)}
          onCallback={(values) => HandleRemoveItem(values)}
          unique="unid_codigo"
        />
      </S.Wrapper>
    </>
  );
}
